import { NgOptimizedImage } from '@angular/common';
import { afterNextRender, ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { OverflowScrollDirective, ScrollChevronComponent } from '@rma/public/generic/public/ui-overflow-scroll';
import { RmaIconComponent } from '@rma/public/generic/ui/icon';
import { ProfileAvatarComponent } from '@rma/public/profiles/public/ui-profile-avatar';
import { CompareTile } from '../domain/compare-tile';

@Component({
  selector: 'rma-compare-tray',
  templateUrl: './compare-tray.component.html',
  imports: [MatButtonModule, NgOptimizedImage, OverflowScrollDirective, ProfileAvatarComponent, RmaIconComponent, ScrollChevronComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareTrayComponent {
  private readonly rendered = signal(false);

  public readonly tiles = input<readonly CompareTile[]>([]);
  public readonly heading = input('');
  public readonly compareLabel = input('');
  public readonly clearLabel = input('');
  public readonly removeLabel = input('');
  public readonly scrollLabel = input('');

  // Empty rather than absent, because animate.enter treats an empty class list as "no animation".
  public readonly trayEnterAnimation = computed(() => (this.rendered() ? 'rma-animate-tray-in' : ''));
  public readonly tileEnterAnimation = computed(() => (this.rendered() ? 'rma-animate-tile-in' : ''));

  public readonly remove = output<string>();
  public readonly clear = output<void>();
  public readonly compare = output<void>();

  public constructor() {
    afterNextRender(() => this.rendered.set(true));
  }
}
